import { OrderOptionsConfig } from './types'

const defaultReorder = <T>(ids: T[]): T[] => ids
const getReorder = <T extends string, OrderOptionKey extends string>(
  orderOptionsConfig: OrderOptionsConfig<T, OrderOptionKey>,
  currentOrderOption: OrderOptionKey | 'custom' | undefined,
) =>
  !currentOrderOption || currentOrderOption === 'custom'
    ? defaultReorder
    : orderOptionsConfig[
        currentOrderOption as Exclude<OrderOptionKey, 'custom'>
      ].reorder

export default getReorder
